<template>
  <div id="fy_tabbar">
    <div class="fy_tabbar_title">
      <!-- Nav tabs -->
      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" class="text-center"
            v-for="(name,index) in title" :key="index">
          <a :href="'#fy_tabbar_0' + (index + 1)" :class="{'tabbar_bold': selectedNum === index}"
             :aria-controls="'fy_tabbar_0' + (index + 1)" role="tab"
             data-toggle="tab" @click="selectedProduct(index)">{{name}}</a>
          <span v-if="selectedNum === index" class="glyphicon glyphicon-triangle-top"></span>
        </li>
      </ul>
    </div>
    <!-- Tab panes -->
    <div id="fy_tab_container" class="tab-content">
      <div v-for="(item,index) in title" role="tabpanel" :class="{'in': index === 0,'active': index === 0}"
           class="tab-pane fade" :id="'fy_tabbar_0' + (index + 1)">
            <fy_intr :pdf-index="index" v-if="isService"></fy_intr>
            <fy_container v-for="(product,listIndex) in productList[index]" :key="listIndex" :container="product"></fy_container>
            <fy_container_card v-for="(item,extendIndex) in extend[index]" :key="'extend' + extendIndex" :card_container="item"></fy_container_card>
            <fy_container_grid v-if="show_grid && index === 0"></fy_container_grid>
            <fy_apply :pdf-index="index" v-if="isService"></fy_apply>
      </div>
    </div>
  </div>
</template>

<script>
    import './../assets/css/fy_tabbar.css'
    import fy_container from "./fy_container"
    import fy_container_card from "./fy_container_card"
    import fy_container_grid from "./fy_container_grid"
    import fy_intr from "./fy_intr"
    import fy_apply from "./fy_apply"

    export default {
        name: "fy_tabbar",
        props: ['title', 'productList','extend','show_grid','isService'],
        components: {
            fy_container,
            fy_container_card,
            fy_container_grid,
            fy_intr,
            fy_apply
        },
        data() {
            return {
                selectedNum: 0,
            }
        },
        methods: {
            selectedProduct(index) {
                this.$emit('clickTab',index)
                this.selectedNum = index
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_tabbar.vue